/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import React, { ReactElement } from "react";
import useForcePasswordChange from "../hooks/useForcePasswordChange";
import useEnforceTwoFactor from "../hooks/useEnforceTwoFactor";
import RegisterTwoFa from "./RegisterTwoFa";
import { Footer } from "../parts";
import WebAuthnDevices from "../pages/userSetting/WebAuthnDevices";
import Password from "../pages/userSetting/Password";

type SucurityGuardProps = {
  children: React.JSX.Element[] | React.JSX.Element | string;
};

const SecurityGuard = ({
  children,
}: SucurityGuardProps): ReactElement<SucurityGuardProps> => {
  const forcePasswordChange = useForcePasswordChange();
  const enforceTwoFactor =
    useEnforceTwoFactor() && window.location.pathname !== "/ShowEula"; // not show enforce for EULA page.
  return (
    (forcePasswordChange && (
      <div className="content-wrapper">
        <div className="content">
          <div className="card p-2">
            <Password />
          </div>
        </div>
        <Footer />
      </div>
    )) ||
    (enforceTwoFactor && (
      <div className="content-wrapper">
        <div className="content">
          <div className="card pt-2">
            <RegisterTwoFa />
            <hr />
            <WebAuthnDevices />
          </div>
        </div>
        <Footer />
      </div>
    )) || <>{children}</>
  );
};

export default SecurityGuard;
